module.exports = __webpack_public_path__ + "static/media/discount_tournament.2a6992bb.svg";